import { useState } from 'react';
import { Popover, Button } from 'antd';

type ShowMoreTextProps = {
    title?: string;
    text: string;
    previewLength?: number;
};

export const ShowMoreText = ({
    title,
    text,
    previewLength = 100,
}: ShowMoreTextProps) => {
    const [open, setOpen] = useState(false);

    const isLong = text.length > previewLength;
    const preview = isLong ? text.slice(0, previewLength) + '...' : text;

    return (
        <div className="flex items-center gap-2">
            <span className="text-textPrimary">{preview}</span>

            {isLong && (
                <Popover
                    content={
                        <div className="max-w-md max-h-60 overflow-y-auto break-words whitespace-pre-wrap">
                            {text}
                        </div>
                    }
                    title={title ?? 'Full Text'}
                    trigger="click"
                    open={open}
                    onOpenChange={setOpen}
                >
                    <Button
                        type="link"
                        className="p-0 text-blue-500 hover:text-blue-700"
                    >
                        more
                    </Button>
                </Popover>
            )}
        </div>
    );
};
